import OrderTypeDropdown from '@/shared/components/OrderTypeDropdown/OrderTypeDropdown';
import { IonGrid, IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import styles from './InfoBox.module.css';
import { useIsMobile } from '@/shared/hooks/devices';

type Props = {
  children: React.ReactNode;
  disabled?: boolean;
  formType: string;
  orderType: string;
  setFormType: (value) => void;
  setOrderType: (value) => void;
  toggleSwitch: {
    labels: string[];
  };
  withDropdown?: boolean;
};

const InfoBox: React.FC<Props> = ({
  children,
  disabled,
  formType,
  orderType,
  setFormType,
  setOrderType,
  toggleSwitch,
  withDropdown
}) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  return (
    <section className={styles.wrapper}>
      <div className={`${isMobile ? styles.containerMobile : styles.container}`}>
        <IonSegment
          disabled={disabled}
          value={formType}
          onIonChange={(event) => event.detail.value && setFormType(event.detail.value)}
          mode={'ios'}
          className={`${styles.segment} ${isMobile && styles.segmentMobile}}`}
        >
          {toggleSwitch.labels.map((label) => (
            <IonSegmentButton value={label} key={label}>
              <IonLabel>{t(`${label}`)}</IonLabel>
            </IonSegmentButton>
          ))}
        </IonSegment>
        {withDropdown && (
          <div className={styles.dropdown}>
            <OrderTypeDropdown disabled={disabled} orderType={orderType} setOrderType={(e) => setOrderType(e)} />
          </div>
        )}
      </div>

      <IonGrid>{children}</IonGrid>
    </section>
  );
};

export default InfoBox;
